import { render, staticRenderFns } from "./lazyLoad.vue?vue&type=template&id=7837d5e9&scoped=true&"
import script from "./lazyLoad.vue?vue&type=script&lang=ts&"
export * from "./lazyLoad.vue?vue&type=script&lang=ts&"
import style0 from "./lazyLoad.vue?vue&type=style&index=0&id=7837d5e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7837d5e9",
  null
  
)

export default component.exports